export const momentsStyle = {
    container: {
        display: { xs: 'initial', xl: 'grid' },
        overflowX: 'hidden',
        overflowY: { xs: 'scroll', xl: 'hidden' },
        height: '100%',
        width: '100vw'
    }
};
